var PriceFilter = (function($, document) {
    'use strict';

    var $document = $(document);

    function PriceFilter(selector, config) {
        this.selector = selector;
        this.config = $.extend({}, this.getDefaultConfig(), config);
        this.onChangeInterval = undefined;
        this.inputCount = 0;
        this.isMobile = false;
    }

    PriceFilter.prototype = {
        getDefaultConfig: function () {
            var noop = function () {};

            return {
                timeout: 650,
                minValue: 0,
                maxValue: 9999,
                onInit: noop,
                onChange: noop
            };
        },

        getConfig: function () {
            return this.config;
        },

        getLowValue: function() {
            return parseInt( $('#filter-price-from').val() || this.config.minValue);
        },

        getHighValue: function() {
            return parseInt( $('#filter-price-to').val() || this.config.maxValue);
        },

        isEmpty: function() {
            return (this.getLowValue() === this.config.minValue && this.getHighValue() === this.config.maxValue);
        },

        clear: function() {
            $('#filter-price-from').val('');
            $('#filter-price-to').val('');

            $document.find(this.selector).trigger('keyup');
        },

        loadEvents: function() {
            var self = this;

            this.isMobile = /(android)/i.test(navigator.userAgent);

            $document.on('focus', this.selector, function() {
                if (self.onChangeInterval) {
                    clearInterval(self.onChangeInterval);
                }

                self.inputCount = 0;
            });

            // $document.on('select', this.selector, function() {
            //     self.inputCount = 1;
            // });

            $document.on('keydown', this.selector, function(e) {
                if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
                    // Allow: Ctrl+A, Command+A
                    (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                    // Allow: home, end, left, right, down, up
                    (e.keyCode >= 35 && e.keyCode <= 40)) {
                    // let it happen, don't do anything
                    return;
                }

                if (e.keyCode === 13) {
                    e.preventDefault();
                }

                // Ensure that it is a number and stop the keypress
                if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                    e.preventDefault();
                }

                var
                    $this = $(this),
                    oldValue = parseInt( $this.val() );

                setTimeout(function () {
                    var newValue = parseInt( $this.val() );

                    if(newValue > self.config.maxValue ) {
                        $this.val(oldValue);
                        self.inputCount = 0;
                        e.preventDefault();
                    }
                }, 1);
            });

            $document.on('keyup', this.selector, function(e) {
                 var
                    $this = $(this),
                    filter = $this.data('filter-name'),
                    from = self.getLowValue(),
                    to = self.getHighValue();

                if( self.isMobile) {

                    if (e.which === 13) {
                        self.config.onChange.call(self, filter, from, to);
                        this.blur();
                    }

                    e.preventDefault();
                    return false;
                }

                ++self.inputCount;

                // is backspace or delete button
                if(e.keyCode === 8 || e.keyCode === 46) {
                    ++self.inputCount;
                }

                if (self.onChangeInterval) {
                    clearInterval(self.onChangeInterval);
                }

                if (self.config.timeout > 0) {
                    self.onChangeInterval = setTimeout(function () {
                        if(self.inputCount > 1) {
                            self.config.onChange.call(self, filter, from, to);
                        }
                    }, self.config.timeout);
                } else {
                    self.config.onChange.call(self, filter, from, to);
                }

                e.preventDefault();
            });

            self.config.onInit.call(self, $(this.selector).data('filter-name'), self.getLowValue(), self.getHighValue());
        }
    };

    return PriceFilter;

})(jQuery, document);
